import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Pagination } from "../../../../../../../common/pagination";
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";
import Heading from '../../../../../../../common/element/Heading';
import ClientInput from "../../../../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import CompanyCoachesList from './CompanyCoachesList';
import AssignCoachDialog from '../../../../ScienceOfSelf/view/Coach/AddCoach';
import { useLocation } from "react-router-dom";
import { getCompanyCoaches, clearCompanyCoaches } from '../../../../../../../redux/Companies/companiesSlice';
import { selectCompanyCoaches, selectCompanyCoachesLoading, selectCompanyCoachesTotal } from '../../../../../../../redux/Companies/companiesSelector';

const CompanyCoaches = ({ companyData }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const companyId = searchParams.get("companyId");

  const [countData, setCountData] = useState(7);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("add")
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const [getFilterData, SetFilterData] = useState({
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  const coaches = useSelector(selectCompanyCoaches);
  const loading = useSelector(selectCompanyCoachesLoading);
  const total = useSelector(selectCompanyCoachesTotal);

  const onEdit = () => {
    setMode("edit")
    setIsOpen(true)
  }
  const onNext = () => { setIsOpen(false) }

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
    setfilterpage(1); // reset page on search
  };

  const inputchangehandler = useCallback(debounce(handleSearch), []);

  // Fetch Company Coaches from API
  const fetchCoaches = useCallback(() => {
    if (!companyId) return;
    dispatch(getCompanyCoaches({
      companyId,
      page: filterpage,
      limit: filterlimit,
      search: getFilterData.search,

    }));
  }, [dispatch, companyId, filterpage, filterlimit, getFilterData.search]);

  useEffect(() => {
    fetchCoaches();
    return () => dispatch(clearCompanyCoaches());
  }, [fetchCoaches, dispatch]);

  // Pagination Handlers
  const handlePageChange = (page) => setfilterpage(page);

  const filteredData = useMemo(() => {
    return coaches; // API already filters and paginates
  }, [coaches]);

  const handleView = (batch) => {
    console.log("view batch", batch);
  };

  const handleAddNew = () => {
    setSelectedBatch(null);
    setIsEdit(false);
    setDialogOpen(true);
  };

  const handleEdit = (batch) => {
    setSelectedBatch(batch);
    setIsEdit(true);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedBatch(null);
    setIsEdit(false);
  };

  return (
    <React.Fragment>
      <div>
        <p className="text-gray-600 my-3"></p>
      </div>

      <ToolManagmentCard >
        <div className="flex justify-between items-center">
          <p className="text-start text-[16px] font-semibold">
            Coaches</p>
          <div className="input-wrapper mb-4">
            {companyData?.company_isActive && <BtnPrimary
              onClick={() => {
                setIsOpen(true);
                setMode("add");
              }}
            >
              Assign Coach
            </BtnPrimary>}

          </div></div>

        <div className="gap-y-4 border-t border-gray-200 py-2"></div>
        <div className="flex justify-end mb-4"></div>

        <CompanyCoachesList sampleData={filteredData} loading={loading} onEdit={onEdit} companyData={companyData} />

        <div className="flex justify-between items-center mt-3">
          <Pagination
            totalCount={total}
            pageNumber={filterpage}
            displayPage={coaches?.length}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />

          {total > 0 && Math.ceil(total / filterlimit) > 1 && (
            <ModernPagination
              totalPages={Math.ceil(total / filterlimit)}
              currentPage={filterpage}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </ToolManagmentCard>

      <AssignCoachDialog
        dialogOpen={isOpen}
        onDialogClose={() => setIsOpen(false)}
        mode={mode}
        onNext={onNext}
        fetchCoaches={fetchCoaches}
      />

    </React.Fragment>
  )
}

export default CompanyCoaches;
